
define('text!common/views/commercial/badge.html',[],function () { return '<div class="ad-slot--paid-for-badge__inner ad-slot__content--placeholder">\n    <h3 class="ad-slot--paid-for-badge__header"><%=header%></h3>\n    <p class="ad-slot--paid-for-badge__header"><%=sponsor%></p>\n</div>\n';});

